export default __webpack_public_path__ + "static/media/imacDemo.1a69d653.webp";